<template>
    <div class="container-scroller">
         <!-- partial -->
        <div class="container-fluid page-body-wrapper">
            <div v-if="isDashboard" class="row row-offcanvas row-offcanvas-right" style="margin-left:-15px;margin-right:-15px">
                <!-- partial:partials/_sidebar.html -->
                <Sidebar></Sidebar>
                <!-- partial -->
<!--                <TopSidebar v-if="isDashboard"></TopSidebar>-->
                <div class="content-wrapper">
                  <div class="col-md-12 col-lg-12 col-xs-12 p-0" style="background:#fff;padding:0 10px!important;border-radius:10px">
                  <div class="row">
                      <div class="col-md-1 col-sm-4 p-0 d-none d-sm-none d-md-none">
                          <nav class="navbar navbar-light p-0">
                              <div class="navbar-menu-wrapper d-flex align-items-center">
                          <button class="navbar-toggler navbar-toggler align-self-center mr-2" type="button" data-toggle="minimize">
                          <span class="navbar-toggler-icon"></span>
                      </button>
                              </div>
                          </nav>
                      </div>
                          <div class="col-lg-7 col-md-7 col-sm-6 col-6  pt-0 pb-0">
                              <div class="row">
                                  <div class="col-md-10 col-sm-12 col-12 pt-0 pb-0">
                                      <h3 class="text-uppercase p-0 m-0" style="height:4.0625rem;line-height:4.0625rem"> {{ headerName }}</h3>
                                  </div>
                              </div>
                          </div>
                      <div class="col-lg-5 col-md-5 col-sm-6 col-6 p-0 text-right navbarToSidebar">
                          <TopSidebar v-if="isDashboard"></TopSidebar>
                      </div>
                      </div>
                      </div>
<div id="beginContent">
                <router-view @checkisDashboard="checkisDashboard"></router-view>
</div>
                </div>
                <!--       footer herer-->
            </div>
            <div v-else class="row" style="margin-left:-15px;margin-right:-15px">
                   <router-view @checkisDashboard="checkisDashboard"></router-view>
                <!-- content-wrapper ends -->
            </div>
            <!-- row-offcanvas ends -->
        </div>
        <!-- page-body-wrapper ends -->
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "Blank",
    data(){
        return{
            isDashboard:false,
        }
    },
        computed:{
            ...mapState('marchands/',['marchand']),
            currentPage (){
                return this.$route.name
            },
        },
        mounted(){
           // let vueBox=this;
           /*  this.$store.dispatch('generalsettings/getGeneralSetting').then(() => {
                if (!vueBox.$route.name.includes('payment.gate')){
                vueBox.$store.dispatch('marchands/getMarchandOne').then(response => {
                    if(response && response.data && response.data.marchand){
                        if (response.data.marchand._valide===false) {
                            vueBox.$store.dispatch('marchands/changesession',response.data.marchand._id)
                        }
                    }
                });
            }
            }); */
        },
        methods:{
          checkisDashboard(isDash){
                this.isDashboard=isDash;
          },
            resetDatas(component){
                Object.assign(component.$data, component.$options.data.apply(component));
                component.loading = false;
            },
        }
    }
</script>

<style scoped>

    @media (max-width: 991px) {
        #beginContent{
            margin-top: 80px;
        }
}
</style>
